// extracted by mini-css-extract-plugin
export default {"default":"delete-button_default__BErcH"};